<template>
    <div>
        <el-dialog
                append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                title="评 价"
                top="30px"
                :visible.sync="dialogShow"
                width="50%"
                :modal-append-to-body="false">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        <!-- {{title}} -->
                                        评 价
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
                <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
            <avue-form 
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                ref="form"
                @error="formError">
                <template slot="target">
                        <el-select
                                v-model="form.target"
                                multiple
                                collapse-tags
                                placeholder="请选择 评价对象"
                        >
                                <el-option
                                v-for="item in evaluateList"
                                :key="item.dictKey"
                                :label="item.dictValue"
                                :value="item.dictKey"
                                >
                                </el-option>
                        </el-select>
                </template>
                
                 <template slot="content">
                <div>
                        <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.content"
                        >
                        </el-input>
                        <remarkModel
                                :remark.sync="form.content"
                                ref="remarkModel123"
                        ></remarkModel>
                </div>
                </template>
                <template slot="attachList">
                        <vupload
                                :fileList.sync="form.attachList"
                                :disabled="false"
                                :showButton="true"
                        ></vupload>
                </template>
                  
                <!-- <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取 消</el-button>
                </template> -->
            </avue-form>
                </div>
                <template slot="footer"> 
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import {
    evaluateOption,
} from "./option.js";
import { 
        getRemarkList,
        evaluation,
 } from "@/api/gateservice/order/order-list/order-list";
 import { getProjectDict } from "@/api/crmedical/project-dictionary/project-dictionary";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{
                attachList:[],
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            data:{},
            cheackedPeople:[],
            userList:[],
            groupList:[],
            dialogShow:false,
            option:evaluateOption,
            orderId:'',
            projectId:"",
            evaluateList:[],
        }
    },
    methods:{
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        openDialog(data){
                this.projectId = data.projectId;
                this.title = data.title;
                        
                        console.log("openDialog")
                        this.orderId = data.orderId;
                        this.form = {
                                orderId:data.orderId,
                                attachList:[],
                        }
                        this.initData();
                
                },
                closeDialog(){
                this.dialogShow = false;
                },
                formError(done){
                done()
        },
        formSubmit1(){
                this.$refs.form.submit();
        },
        formSubmit(form,done){
                form.detailList = [];
                this.option.column.forEach((ele) => {
                        if (ele.prop != "remark" && ele.prop != "attachList") {
                        let temObj = { target: ele.prop, level: form[ele.prop] };
                        form.detailList.push(temObj);
                        }
                });
                if (form.detailList.length == 0) {
                        this.$message({
                        message: "缺少打分项",
                        type: "warning",
                        });
                        done();
                        return;
                }
                let contentFlag = false;
                for (let i = 0; i < this.evaluateList.length; i++) {
                        if (!form.detailList[i].level) {
                        this.$message({
                        message: `请评价${this.option.column[i].label}`,
                        type: "warning",
                        });
                        done();
                        return;
                        }

                        if (form[this.evaluateList[i].dictKey] < 3) {
                        contentFlag = true;
                        break;
                        }
                }
                if (contentFlag) {
                        if (!form.remark) {
                        this.$message({
                        message: "请填写差评信息",
                        type: "warning",
                        });
                        done();
                        return;
                        }
                }
            
                evaluation(form).then(res=>{
                        if(res.msg=='操作成功'){
                        this.$message({
                                message: res.msg,
                                type: 'success'
                        });
                        this.dialogShow = false;
                        }else{
                        this.$message.error(res.msg);
                        }
                        this.$emit('handleClose',function(){console.log('关闭历程表')})
                        
                        this.dialogShow = false;
                        done()
                }).catch(err=>{
                        
                        
                        done()
                })
        },
        // 初始化数据
        async initData(){
            
                // 获取备注模板
                getRemarkList({orderId:this.orderId,actionType:9}).then(res=>{
                        this.$refs.remarkModel123.setRemarkList(res.data);
                })
                getProjectDict({
                                code: "project_order_evaluate_target",
                                projectId: this.projectId,
                        }).then((res) => {
                                let temArr = [];
                                res.data.forEach((ele) => {
                                        let temObj = {
                                                type: "rate",
                                                label: ele.dictValue,
                                                span: 12,
                                                display: true,
                                                max: 5,
                                                required: true,
                                                rules: [
                                                                {
                                                                        required: true,
                                                                        message: "请评价",
                                                                        trigger: "blur",
                                                                },
                                                        ],
                                                value: 0,
                                                texts: ["很差", "差", "一般", "好", "很好"],
                                                colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
                                                prop: ele.dictKey,
                                                showText: true,
                                        };
                                        temArr.push(temObj);
                                });
                                this.option.column = [
                                        ...temArr,
                                        ...this.option.columnCopy,
                                ];
                                this.evaluateList = res.data;
                                this.dialogShow = true;
                });
        },
       
       
    }
}
</script>
